import React from 'react';
import Meta from './../components/Meta';
import AdminLandingSection from './../components/AdminLandingSection';

function AdminHomePage() {
  return (
    <>
      <Meta title="Showrunner Admin — Gallery Dashboard" />
      <AdminLandingSection />
    </>
  );
}

export default AdminHomePage;
